import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads record warnings when record occupants are added, removed, or updated.
 */
export const loadForCurrentEntityOnOccupantsChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceOccupant, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(occupantsEc =>
        occupantsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
      ),
      rxjs.map(() =>
        feature.actions.loadForCurrentEntity.request
          .from(
            '(effect) load record warnings for current entity on occupants change',
          )
          .create(),
      ),
    ),
)
